const $ = jQuery.noConflict()

import lockScroll from '../__utils/lockScroll';

class VideoLightbox {
    constructor() {
        this.btnOpenLightbox = document.querySelectorAll('[data-lightbox-video]');
        this.lightboxClose   = document.querySelectorAll('.video-lightbox__close');
        this.lightboxWrapper = document.querySelector('.video-lightbox');
        this.player          = document.getElementById('player');
        this.isIframe        = false;
    }

    init() {
        this.btnOpenLightbox.forEach(btn => btn.addEventListener('click', this.openLightbox.bind(this)));
        this.lightboxClose.forEach(btn => btn.addEventListener('click', this.closeLightbox.bind(this)));
    }

    openLightbox(e) {
        e.preventDefault();
        const url = e.currentTarget.dataset.lightboxVideo;

        if ( url ) {
            if ( !this.isIframe ) {
                const iframe = document.createElement('iframe');
                this.player.appendChild(iframe);
                this.isIframe = true;
            }
            const iframeVideo = this.player.querySelector('iframe');

            if (this.isYT(url)) {
                var match = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/);
                if (match && match[2].length == 11) {
                    iframeVideo.setAttribute('allow','autoplay');
                    iframeVideo.src = '//www.youtube.com/embed/' + match[2] + '?autoplay=1';
                }
            } else if ( this.isVimeo(url) ) {
                iframeVideo.setAttribute('allow','autoplay');
                iframeVideo.src = this.getVimeoEmbedUrl(url);
                iframeVideo.src += '?autoplay=1';
            } else if (this.isWistia(url)) {
                const id = this.isWistia(url);
                iframeVideo.src = `https://fast.wistia.net/embed/iframe/${id}`;
                iframeVideo.src += '?volume=1';
                iframeVideo.src += '&muted=0';
                iframeVideo.src += '&autoPlay=1';
            }
            this.lightboxWrapper.classList.add('active');
            lockScroll.lock();
        }
    }

    closeLightbox() {
        this.player.querySelector('iframe').setAttribute('src','');
        this.lightboxWrapper.classList.remove('active');
        lockScroll.unlock();
    }


    keyDown(e) {
        const lightboxWrapper = document.querySelector('.video-lightbox__wrapper.active');
        if (e.keyCode == 27 && lightboxWrapper) {
            this.closeLightbox();
        }
    }

    isYT(url) {
        const yt = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        return (url.match(yt)) ? RegExp.$1 : false;
    }

    isVimeo(url) {
        const vimeo = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
        return (url.match(vimeo)) ? RegExp.$5 : false;
    }

    isWistia(url) {
        const wistia = /(?:(?:medias|iframe)\/|wvideo=)([\w-]+)/;
        return (url.match(wistia)) ? RegExp.$1 : false;
    }

    getVimeoEmbedUrl(url) {
        let matches = url.match(/(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
        if ( null !== matches ) {
            return 'https://player.vimeo.com/video/' + matches[5];
        }
    }

    resized() {
        const containerSize = 1300;
        const maxHeight     = containerSize * (9/16) - 50;

        if ( window.innerHeight < maxHeight ) {
            $('.video-lightbox__container').css('max-width', (window.innerHeight - 100) * (16/9) ); 
        } else {
            $('.video-lightbox__container').css('max-width', 'none');
        }
    }
}

export default new VideoLightbox();
